import script from "./newsLatestListingVertical.vue?vue&type=script&setup=true&lang=js"
export * from "./newsLatestListingVertical.vue?vue&type=script&setup=true&lang=js"

import "./newsLatestListingVertical.vue?vue&type=style&index=0&id=70b1e3af&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b1e3af"]])

export default __exports__